import { useState } from 'react';

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { Button, Container } from '@mui/material';
import IconButton from '@mui/material/IconButton';

import Typescript from '@mui/material/Typography'

import Title from '../../components/Title'
import Text from '../../components/Text'

import icon_1 from '../../images/image.png'

import image from '../../images/symptoms/Fragole.png'

function Wirtspflanzen() {

  return (

    <Container className="brown">

      <Grid container flexDirection="row" className="px-0">

        <Grid className="p-3" size={{ xs: 12, sm: 12, md: 9 }}>

          <Title text="wirtspflanzen_title" variant="big" color="orange"></Title>

          <ul className="list-disc white">
            <li>
              <Text variant="normal"
                text="wirtspflanzen_1">
              </Text>
            </li>
            <li>
              <Text variant="normal"
                text="wirtspflanzen_2">
              </Text>
            </li>
            <li>
              <Text variant="normal"
                text="wirtspflanzen_3">
              </Text>
            </li>
            <li>
              <Text variant="normal"
                text="wirtspflanzen_4">
              </Text>
            </li>

          </ul>

        </Grid>

        <Grid size={{ xs: 12, sm: 12, md: 3 }}>
          <img src={image} />
        </Grid>
      </Grid>

    </Container>
  );
}

export default Wirtspflanzen;
